<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
          <div class="p-col-12 p-lg-6 p-mt-2">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10 p-lg-10">
                <label class="p-mr-2">{{ $t("agency") }}</label>
                <Button
                  @click="showOrganize = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="organize_table"
                :scrollable="true"
                scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
               
                :selection.sync="selectedOrganizeData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="organize_name"
                  :header="$t('id_operating_name')"
                  :sortable="true"
                  headerStyle="width: 20rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.organize_id }}</div>
                    {{ dataTable.data.organize_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            organizeDelete = dataTable.data;
                            alertDisplay(organizeDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col p-mt-3 p-ml-3">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10 p-lg-11 p-mt-2">
                <label>{{ $t("officerlevel") }}</label>
                <MultiSelect
                  v-model="levelSelected"
                  :options="levelOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div>{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-2 p-lg-1 p-mt-5">
                <Button
                  @click="levelSelected = null
                          multiSelectClearFilerValue +=1;"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_level == true">{{
              $t("table_validate")
            }}</span>

            <div class="p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-10 p-lg-11 p-mt-2">
                <label>{{ $t("responsework") }}</label>
                <MultiSelect
                  v-model="specialSelected"
                  :options="specialOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-2 p-lg-1 p-mt-5">
                <Button
                  @click="specialSelected = null
                          multiSelectClearFilerValue +=1;"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_response == true">{{
              $t("table_validate")
            }}</span>

            <div class="p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-10 p-lg-11 p-mt-2">
                <label>{{ $t("disaster_related") }}</label>
             
                <!-- <MultiSelect
                  v-model="disasterTypeSelected"
                  :options="disasterTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                > -->
                   <MultiSelect
                  v-model="disasterTypeSelected"
                  :options="disasterTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-2 p-lg-1 p-mt-5">
                <Button
                  @click="disasterTypeSelected = null
                          multiSelectClearFilerValue +=1;"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_disaster == true">{{
              $t("table_validate")
            }}</span>



            <div class="p-formgrid p-grid p-mt-4 p-jc-end">
              <div class="p-field p-col p-mt-2">
                <!-- <Button
                  @click="exportCSV()"
                  :label="$t('exportBtn')"
                  class="p-button-info p-mr-3"
                  style="background-color: green"
                /> -->
                
              
                <Button
                  @click="clearSearchField()"
                  :label="$t('clearBtn')"
                  class="p-button-clear p-mr-3"
                />
                <Button
                  @click="search()
                  cou= true"
                  :label="$t('searchBtn')"
                  class="p-button-info p-mr-2"
                />
              </div>
            </div>

          </div>
        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>
    <!-- :contentStyle="{ 'overflow-y': 'scroll' }" -->
    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
      
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
        :parentmessage="parentmessage_organize"
      ></organize-table>
    </Dialog>

    <div class="card p-fluid p-mt-2">
      <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
      <DataTable
        :value="table"
        :scrollable="true"
      scrollHeight="500px"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :sortOrder="1"
        sortField="index"
        ref="dt"
        :exportFilename = "`รายละเอียดข้อมูลเจ้าหน้าที่-${date}`"
        :rowHover="true"
        :filters="filters"
        
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
      <!-- Doe : เพิ่ม ลำดับ 1/4  จบ sortField="index" :sortOrder="1" -->
        <!-- <template #header>
          <div class="table-header p-col-6 p-lg-3" style="margin-left: auto">
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div>
        </template> -->
        <template #header>
          <div class="p-grid p-col ">
            
             <!-- Doe : PDF 1/3 -->
             <div class="table-header "  style="padding: 7px;"   >
              <Button
                    
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info "
                   
                    style="background-color: green;"
                  />
            </div>
            <div class="table-header " style="padding: 7px;"  >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

            <!-- Doe PDF เลือกได้  1/5   -->
            <div class="table-header" id="TABLE_EDIT" style="padding: 7px;"  >
                <Button
                @click="EditPDF()"
                icon="pi pi-cog"
                :label="'ตั้งค่า'"
                style="background-color: #0288D1;
                       border: 1px solid #0288D1;"
                />
            </div>
            <!-- Doe PDF เลือกได้  1/5 จบ  -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

              <!-- Doe ค้นหา  1/5 -->

              <span class="p-input-icon-left" v-if="columns_disabled && cou" >    
                    <i class="pi pi-search" />
                    <InputText
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
                <span class="p-input-icon-left" v-else >
                    <i class="pi pi-search" />
                    <InputText
                    disabled
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
              <!-- Doe ค้นหา  1/5 จบ-->
              
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <!--Doe : เพิ่มลำดับ 2/4-->
        <div v-if="columns_index == true">
          <Column
            field="index"
            :header="'ลำดับ'"
            :sortable="true"
            :headerStyle="{width: '8rem',textAlign:'center'}"
          >
            <template #body="dataTable">  
              <div class="table_row">
                {{ dataTable.data.index }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        <!--Doe : เพิ่มลำดับ 2/4 จบ-->

        <div v-if="columns_organize_name == true">
          <Column field="organize_name" :header="$t('agency')" :sortable="true" headerStyle="width: 15rem">
            <template #body="dataTable">
              {{ dataTable.data.organize_name }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_level_name == true">
          <Column
            field="level_name"
            :header="$t('officerlevel')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.level_name == null" class="table_row">-</div>
              <div v-else class="table_row">{{ dataTable.data.level_name }}</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_special_details == true">
          <Column field="special_details" :header="$t('responsework')" :sortable="true" headerStyle="width: 15rem">
            <template #body="dataTable">
              <div v-if="dataTable.data.specialist_id == '[]'">-</div>
              <div v-else>
                <div
                  v-for="response in JSON.parse(dataTable.data.specialist_id)"
                  :key="response.specialist_id"
                >
                  {{ response.system_name }}
                </div>
              </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_disaster_details == true">
          <Column field="disaster_details" :header="$t('disaster_related')" :sortable="true" headerStyle="width: 15rem">
            <template #body="dataTable">
              <div v-if="dataTable.data.disaster_id == '[]'">-</div>
              <div v-else>
                <div
                  v-for="disaster in JSON.parse(dataTable.data.disaster_id)"
                  :key="disaster.disaster_id"
                >
                  {{ disaster.system_name }}
                </div>
              </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        
        <div v-if="columns_officer_fullname == true">
          <Column
            field="officer_fullname"
            :header="$t('fullname')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.officer_fullname }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_officer_response_signal == true">
          <Column
            field="officer_response_signal"
            :header="$t('response_signal')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.officer_response_signal == ''">-</div>
              <div v-else>{{ dataTable.data.officer_response_signal }}</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_officer_mobile_phone == true">
          <!-- <Column
            field="officer_mobile_phone"
            :header="$t('phone_number')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.officer_mobile_phone == ''">-</div>
              <div v-else>{{ dataTable.data.officer_mobile_phone }}</div>
            </template>
          </Column> -->
          <Column  
          field="text_tel_detail"  
          :header="$t('phone_number')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
      
            <span v-html="dataTable.data.text_tel_detailHTML"></span>
          </template>
        </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

      </DataTable>
    </div>
    
    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Doe PDF เลือกได้  -->
    <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" 
    :style="{ width: '25rem' }"  
    :contentStyle="{ 'overflow-y': 'visible' }"
    > 
    <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
        <div style="margin: 2.5rem 1rem 0 1rem;">
          <div class="p-formgrid p-grid">
              <div class="p-field p-col-12">
          
                      <MultiSelect
                        v-model="columnsSelectorDialog"
                        :options="columns"
                        optionLabel="title"
                        :placeholder="$t('placeholderSelectBox')"
                        :filter="true"
                        class="multiselect-custom"
                        :clearFilterMultiSelect="multiSelectClearFilerValue"
                      >
                        <template #value="slotProps">
                          <div
                            class="item item-value"
                            v-for="option of slotProps.value"
                            :key="option.dataKey"
                          >
                            <div>{{ option.title }}</div>
                          </div>
                          <template
                            v-if="!slotProps.value || slotProps.value.length === 0"
                          >
                            {{ $t("placeholderSelectBox") }}
                          </template>
                        </template>
                        <template #option="slotProps">
                          <div class="item">
                            <div >{{ slotProps.option.title }}</div>
                          </div>
                        </template>
                      </MultiSelect>
                      <div style="margin-top: 1rem; 
                                  display:flex;
                                  justify-content: flex-end;">
                        <Button
                        @click="ClearEditPDF()
                                multiSelectClearFilerValue +=1"
                        class="p-button-clear"
                        :label="'ล้างข้อมูล'"
                        style="margin-right: 1rem;"
                        />
                        <Button
                        @click="SelectAllEditPDF()"
                        class="p-button-info"
                        :label="'เลือกทั้งหมด'"
                        

                        />
                      </div>
                      
              </div>
          </div>
        </div>
        <template #footer>
          <div>
            <Button
            @click="CloseEditPDF()"
            :label="'ยกเลิก'"
            icon="pi pi-times"
            class="p-button-text"
            />
            <Button
            @click="SaveEditPDF()"
            :label="'บันทึก'"
            icon="pi pi-check"
            class="p-button-text"
            />
          </div>
        </template>
      
      </Dialog>
       <!-- Doe PDF เลือกได้ -->

  </div>
</template>

<script>
// Doe : PDF 2/3 
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import organizeTable from "../OrganizeMultiSelectTable";
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "report-officer-detail",
  components: {
    organizeTable,
    textFooter
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ

      table: [],
      filters: {},
      displayConfirmation: false,
      showOrganize: false,

      levelOptions: [],
      levelSelected: null,

      disasterTypeOptions: [],
      disasterTypeSelected: null,

      specialOptions: [],
      specialSelected: null,

      selectedOrganizeData: null,
      organize_table: [],

      organizeDelete: null,
      error_level: false,
      error_response: false,
      error_disaster: false,

      loading: false,

      parentmessage_organize: null,

      CurrentPageReport: null,
      FirstPageLink: null,
      PreviousPageLink: null,
      PageLinks: null,
      NextPageLink: null,
      LastPageLink: null,
      RowsPerPageDropdown: null,

      // Doe PDF เลือกได้  2/5

      setPDF_Hor:"l",
      setPosition_Hor:[802,34,802,570],
      setPDF_Ver:"p",
      setPosition_Ver:[570,34,575,815],
      setPDF_Styles:"grid",
      setnamePDF:"ตารางรายละเอียดข้อมูลเจ้าหน้าที่",
      setPDF_fillColor:[95,154,250],
      setPDF_Margin:{ left: 15 ,right: 15 },

      PDF_minCellWidthVer: 70,
      PDF_FontHeaderVer:13,
      PDF_FontBodyVer:10,

      PDF_BodySizeSelect:{},
      PDF_BodySize:{
                          index: {cellWidth: 35},
                          organize_name: {cellWidth: 60},
                          level_name:{cellWidth: 65},
                          special_details:{cellWidth:90},
                          
                          officer_response_signal:{cellWidth:60},
      },
      
      PDF_minCellWidthHor: 70,
      PDF_FontHeaderHor:15,
      PDF_FontBodyHor:12,

      PDF_BodySizeHorSelect:{},
      PDF_BodySizeHor:{
                          index: {cellWidth: 35},
                          organize_name: {cellWidth: 90},
                          level_name:{cellWidth: 80},
                          special_details:{cellWidth:90},

                          officer_response_signal:{cellWidth:70},
                          // officer_mobile_phone:{cellWidth:70}  
                          text_tel_detail:{cellWidth:70} 
      },
      columns:[
                  {title: "ลำดับ", dataKey: "index" },
                  {title: "หน่วยงานต้นสังกัด", dataKey: "organize_name" },
                  {title: "ระดับเจ้าหน้าที่", dataKey: "level_name" },
                  {title: "ความเชี่ยวชาญ", dataKey: "special_details" },
                  {title: "สาธารณภัยที่เกี่ยวข้อง", dataKey: "disaster_details" },
                  {title: "ชื่อ-นามสกุล", dataKey: "officer_fullname"},
                  {title: "สัญญาณเรียกขาน", dataKey: "officer_response_signal"},
                  // {title: "เบอร์โทรศัพท์", dataKey: "officer_mobile_phone"},
                  {title: "เบอร์โทรศัพท์", dataKey: "text_tel_detail"},

              ],

      columnsSelector:null,
      columnsSelectorDialog:null,
      
      displayEditPDF:false,

      columns_index:true,
      columns_organize_name:true,
      columns_level_name:true,
      columns_special_details:true,
      columns_disaster_details:true,
      columns_officer_fullname:true,
      columns_officer_response_signal:true,
      columns_officer_mobile_phone:true,
      // columns_organize_name:true,

      columns_disabled:true,
      GetData_ColumnsSearch:[],
      // Doe PDF เลือกได้  2/5  จบ

      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"หน่วยงานต้นสังกัด",
          textShow:"",
        },
        {
          DataName:"ระดับเจ้าหน้าที่",
          textShow:"",
        },
        {
          DataName:"ความเชี่ยวชาญ",
          textShow:"",
        },
        {
          DataName:"สาธารณภัยที่เกี่ยวข้อง",
          textShow:"",
        },
      ],

      // Doe : PDF 3/3
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
              this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});

                let columns = this.columnsSelector

                const Body_setCenter = ["index","level_name"]

                const PintPDF = {
                  streak:this.setPDF_Ver,
                  setPosition:this.setPosition_Ver,
                  PDF_Styles:this.setPDF_Styles,
                  data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeSelect,
                  FileName:this.setnamePDF,
                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderVer,
                  Body_FontSize:this.PDF_FontBodyVer,
                  minCell:this.PDF_minCellWidthVer,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor,
                }

                this.printPDF(PintPDF) 
              }
            }
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
              let columns = this.columnsSelector

              const Body_setCenter = ["index","level_name"]

              const PintPDF = {
                streak:this.setPDF_Hor,
                setPosition:this.setPosition_Hor,
                PDF_Styles:this.setPDF_Styles,
                data:this.$refs.dt.processedData,
                columns:columns,
                columnsStyles:this.PDF_BodySizeHorSelect,
                FileName:this.setnamePDF,
                checkBody_Center:true,
                Body_Center:Body_setCenter,
                Col_FontSize:this.PDF_FontHeaderHor,
                Body_FontSize:this.PDF_FontBodyHor,
                minCell:this.PDF_minCellWidthHor,
                marginPDF:this.setPDF_Margin,
                fillColorPDF:this.setPDF_fillColor,
              }

              this.printPDF(PintPDF) 
            }
          }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },
  watch: {
    showOrganize(val) {
      if (val == true) {
        if (this.organize_table.length > 0) {
          this.parentmessage_organize = this.organize_table;
        } else {
          this.parentmessage_organize = [];
        }
      }
    },

    levelOptions(val) {
      if (val != null) {
        this.levelSelected = val;
      }
    },

    specialOptions(val) {
      if (val != null) {
        this.specialSelected = val;
      }
    },

    disasterTypeOptions(val) {
      if (val != null) {
        this.disasterTypeSelected = val;
      }
    },

    levelSelected(val) {
      if (val != null) {
        this.error_level = false;
        if (val.length == 0) {
          this.levelSelected = null;
        }
      }
    },

    specialSelected(val) {
      if (val != null) {
        this.error_response = false;
        if (val.length == 0) {
          this.specialSelected = null;
        }
      }
    },

    disasterTypeSelected(val) {
      if (val != null) {
        this.error_disaster = false;
        if (val.length == 0) {
          this.disasterTypeSelected = null;
        }
      }
    },

    table(val) {
      if (val.length > 0) {
        this.loading = false;
      }
    },

    // Doe PDF เลือกได้
    columnsSelector(val){
      
      if (val.length == 0) {
        this.table = []
      }else{
        this.table = this.cloneTable
      }
    },

  },

  async created() {

    // Doe PDF เลือกได้  4/5  
    this.columnsSelector = this.columns
      this.PDF_BodySizeSelect = this.PDF_BodySize
      this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor

      // Doe PDF เลือกได้  4/5  จบ

    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-08" },
      })
      .then((response) => {
        this.levelOptions = response.data.data;
      });
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-07" },
      })
      .then((response) => {
        this.specialOptions = response.data.data;
      });
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-02" },
      })
      .then((response) => {
        this.disasterTypeOptions = response.data.data;
      });

      this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)
  },
  mounted() {},
  methods: {
    exportCSV() {
      if (this.table != "") {
      debugger;
      this.$refs.dt.exportCSV();
      }
    },
    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      if (variable != null) {
        this.organize_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.organize_table.push({
            organize_id: variable[i].organize_id,
            organize_name: variable[i].organize_name,
          });
        }
      }
    },

    // Doe ค้นหา  3/6 
    searchTable(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.table = this.cloneTable.filter((item) => {

          // return item.organize_name.includes(this.filter) ||
          //     item.level_name.includes(this.filter)||
          //     item.special_details.includes(this.filter)||
          //     item.disaster_details.includes(this.filter)||
          //     item.officer_fullname.includes(this.filter)||
          //     item.officer_response_signal.includes(this.filter)||
          //     item.officer_mobile_phone.includes(this.filter)
          return (this.columns_organize_name ? item.organize_name.includes(this.filter) : "") ||
                 (this.columns_level_name ? item.level_name.includes(this.filter) : "") ||
                 (this.columns_special_details ? item.special_details.includes(this.filter) : "") ||
                 (this.columns_disaster_details ? item.disaster_details.includes(this.filter) : "") ||
                 (this.columns_officer_fullname ? item.officer_fullname.includes(this.filter) : "") ||
                 (this.columns_officer_response_signal ? item.officer_response_signal.includes(this.filter) : "") ||
                //  (this.columns_officer_mobile_phone ? item.officer_mobile_phone.includes(this.filter) : "") 
                 (this.columns_officer_mobile_phone ? item.text_tel_detail.includes(this.filter) : "") 

      });

      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }

      return (this.table)

      }else{
        // console.log("5555")
      this.table = this.cloneTable
      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
      }
      this.table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    async search() {
      this.filter='';
      this.cloneTable=[];
      this.loading = true;

      if (
        this.levelSelected != null &&
        this.specialSelected != null &&
        this.disasterTypeSelected != null
      ) {
        await this.axios
          .post(`${this.$url_service}/get/report`, {
            body: {
              topic: "get-report-officer",
              subtopic: "get-report-officer-detail",
              organize: this.organize_table,
              level: this.levelSelected,
              response: this.specialSelected,
              disaster: this.disasterTypeSelected,
            },
          })
          .then((response) => {
            this.table = response.data.data
            // Doe ค้นหา  4/6 
            this.cloneTable = response.data.data
            // Doe ค้นหา  4/6 

          // Doe : เพิ่ม ลำดับ 3/3  
          for (let i = 0; i < this.table.length; i++) { 
            this.table[i]["index"] =i+1;
          }
          // Doe : เพิ่ม ลำดับ 3/3
          // Doe : เพิ่ม ความเชี่ยวชาญ สาธารณภัยที่เกี่ยวข้อง
            var special = this.table.map(obj => 
            special= obj.specialist_id)

              // console.log('special is ',special);

            for (let index = 0; index < special.length; index++) {
              const element = special[index];
  
                  let textAll = ''
                      for (let index = 0; index < JSON.parse(element).length; index++) {

                        const element2 = JSON.parse(element)[index].system_name;
                        textAll += `${element2}\n`;
                      }
      
                      this.table[index]["special_details"] = textAll
               
            }

            var disaster = this.table.map(obj => 
            special= obj.disaster_id)

            for (let index = 0; index < disaster.length; index++) {
              const element = disaster[index];
  
                  let textAll = ''
                      for (let index = 0; index < JSON.parse(element).length; index++) {

                        const element2 = JSON.parse(element)[index].system_name;
                        textAll += `${element2}\n`;
                      }
                      this.table[index]["disaster_details"] = textAll

            }
            // console.log("table",this.table)
            
            // Doe ช่องว่างใส่ ขีด
          for (let index = 0; index < this.table.length; index++) {

              if (this.table[index].level_name == null ||
                  this.table[index].level_name == "null" ||
                  this.table[index].level_name == "" ) {
                this.table[index].level_name = "-"
              }
              if (this.table[index].special_details == null ||
                  this.table[index].special_details == "null" ||
                  this.table[index].special_details == "" ) {
                this.table[index].special_details = "-"
              }
              if (this.table[index].disaster_details == null ||
                  this.table[index].disaster_details == "null" ||
                  this.table[index].disaster_details == "" ) {
                this.table[index].disaster_details = "-"
              }
              if (this.table[index].officer_response_signal == null ||
                  this.table[index].officer_response_signal == "null" ||
                  this.table[index].officer_response_signal == "" ) {
                this.table[index].officer_response_signal = "-"
              }
              if (this.table[index].officer_mobile_phone == null ||
                  this.table[index].officer_mobile_phone == "null" ||
                  this.table[index].officer_mobile_phone == "" ) {
                this.table[index].officer_mobile_phone = "-"
              }
              if (this.table[index].text_tel_detail == null ||
                  this.table[index].text_tel_detail == "null" ||
                  this.table[index].text_tel_detail == "" ) {
                this.table[index].text_tel_detail = "-"
              }

          }
          // Doe ช่องว่างใส่ ขีด

          this.setSearchText_Footer()

          });

          if (this.columns_disabled == true) {
            this.table = this.cloneTable
          }else{
            this.table = []
          }

        this.loading = false;
      } else {
        this.table = [];
        if (this.levelSelected == null) {
          this.error_level = true;
        }
        if (this.specialSelected == null) {
          this.error_response = true;
        }
        if (this.disasterTypeSelected == null) {
          this.error_disaster = true;
        }

        this.loading = false;

        
      }
    },
    setSearchText_Footer(){
          this.text_Footer=false;
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.organize_table.length !== 0 ||
              this.levelSelected.length !== 0 ||
              this.specialSelected.length !== 0 ||
              this.disasterTypeSelected.length !== 0   ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "หน่วยงานต้นสังกัด" && this.organize_table.length !== 0){
                  element.textShow = this.setArray_to_Text(this.organize_table,"organize_name")
                }
                if(element.DataName === "ระดับเจ้าหน้าที่" && this.levelSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.levelSelected,"system_name")
                }
                if(element.DataName === "ความเชี่ยวชาญ" && this.specialSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.specialSelected,"system_name")
                }
                if(element.DataName === "สาธารณภัยที่เกี่ยวข้อง" && this.disasterTypeSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.disasterTypeSelected,"system_name")
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text(data,name){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          text += element[name] + ",";
        }
      }
      return text.slice(0, -1)
    },

    confirmDelete() {
      this.displayConfirmation = false;
      this.organize_table = this.organize_table.filter(
        (val) => val !== this.organizeDelete
      );
    },

    clearSearchField() {
      this.table = [];
      this.organize_table = [];
      this.levelSelected = null;
      this.specialSelected = null;
      this.disasterTypeSelected = null;
      this.error_level = false;
      this.error_response = false;
      this.error_disaster = false;
      this.multiSelectClearFilerValue +=1;
      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
      // Doe ค้นหา
      this.filter='';
      this.cloneTable=[];
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },

     // Doe PDF เลือกได้  5/5  
     EditPDF(){
        this.displayEditPDF = true
        this.columnsSelectorDialog = this.columnsSelector
        
      },
      SaveEditPDF(){

        if(this.columnsSelectorDialog.length <= 4){
        this.PDF_minCellWidthVer = 120 
        this.PDF_FontHeaderVer = 13
        this.PDF_FontBodyVer = 10
       
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        }

        this.PDF_minCellWidthHor = 130
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12

        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }
      }else{
        
        this.PDF_minCellWidthVer = 70
        this.PDF_FontHeaderVer = 13
        this.PDF_FontBodyVer = 10
        this.PDF_BodySizeSelect = this.PDF_BodySize  

        this.PDF_minCellWidthHor = 70
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      }
        
      this.columnsSelector = this.columnsSelectorDialog

        if (this.columnsSelectorDialog.length == 0) {
          
          this.columns_index = false
          this.columns_organize_name = false
          this.columns_level_name = false
          this.columns_special_details = false
          this.columns_disaster_details = false
          this.columns_officer_fullname = false
          this.columns_officer_response_signal = false
          this.columns_officer_mobile_phone = false

          this.columns_disabled = false
        }else if(this.columnsSelectorDialog.length == 8){
            
            this.columns_index = true
            this.columns_organize_name = true
            this.columns_level_name = true
            this.columns_special_details = true
            this.columns_disaster_details = true
            this.columns_officer_fullname = true
            this.columns_officer_response_signal = true
            this.columns_officer_mobile_phone = true
            
            this.columns_disabled = true
        }  
        else{
          this.columns_disabled = true
          // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);
          
          
          let getData = []    
          // ! จัดข้อมูล
          for (let index = 0; index < this.columnsSelector.length; index++) {
            getData.push(this.columnsSelector[index].dataKey);
          }
          
          // console.log("getData",getData);

          // ! เช็คข้อมูล

          for (let index = 0; index < this.columnsSelector.length; index++) {
              const element = this.columnsSelector[index].dataKey
        
              if (element == "index") {
                this.columns_index = true
              } else if(!getData.includes("index")){
                // console.log("getData.includes(index)",getData.includes("index"))
                this.columns_index = false
              }

              if (element == "organize_name") {
                this.columns_organize_name = true 
              }else if(!getData.includes("organize_name")){
                
                this.columns_organize_name = false
              }

              if (element == "level_name") {
                this.columns_level_name = true 
              }else if(!getData.includes("level_name")){
                
                this.columns_level_name = false
              }

              if (element == "special_details") {
                this.columns_special_details = true 
              }else if(!getData.includes("special_details")){
                
                this.columns_special_details = false
              }

              if (element == "disaster_details") {
                this.columns_disaster_details = true 
              }else if(!getData.includes("disaster_details")){
                
                this.columns_disaster_details = false
              }

              if (element == "officer_fullname") {
                this.columns_officer_fullname = true 
              }else if(!getData.includes("officer_fullname")){
                
                this.columns_officer_fullname = false
              }

              if (element == "officer_response_signal") {
                this.columns_officer_response_signal = true
              } else if(!getData.includes("officer_response_signal")){
                this.columns_officer_response_signal = false
              }

              // if (element == "officer_mobile_phone") {
              //   this.columns_officer_mobile_phone = true 
              // }else if(!getData.includes("officer_mobile_phone")){
                
              //   this.columns_officer_mobile_phone = false
              // }

              if (element == "text_tel_detail") {
                this.columns_officer_mobile_phone = true 
              }else if(!getData.includes("text_tel_detail")){
                
                this.columns_officer_mobile_phone = false
              }

          }

        }

        this.displayEditPDF = false
        this.filter = ""

      },
      CloseEditPDF(){
        this.displayEditPDF = false
      },
      ClearEditPDF(){
        this.columnsSelectorDialog = []
        
      },
      SelectAllEditPDF(){
        this.columnsSelectorDialog = this.columns
        
      },
      // Doe PDF เลือกได้  5/5 จบ

  },
};
</script>

<style scoped>

.table_row{
  text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT{
    width: 149px;
  }
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
      .p-dialog-content{
        overflow-y: auto;
      }
    }
    
  }
.p-multiselect {
  // min-width: 18rem;
  max-width: 60rem;
  // width: fit-content;
}
@media screen and (max-width: 1540px) {
    .p-multiselect {
        max-width: 40rem !important
    }
}

@media screen and (max-width: 640px) {
    .p-multiselect {
        max-width: 10rem !important
    }
}

.multiselect-custom {
  // Doe PDF เลือกได้
  width: 100%;
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    
  }


  

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>
